import { AdminRole, normalizeRole } from './adminPermissions';

export function formatDisplayName(nameOrEmail: string | null | undefined): string {
  if (!nameOrEmail?.trim()) return 'Admin';

  const raw = nameOrEmail.trim();
  if (!raw.includes('@')) {
    return raw
      .split(/\s+/)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
      .join(' ');
  }

  const localPart = raw.split('@')[0] ?? raw;
  return localPart
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

export function getFirstName(displayName: string): string {
  return displayName.split(/\s+/)[0] || displayName;
}

export function getInitials(displayName: string): string {
  const parts = displayName.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  return displayName.slice(0, 2).toUpperCase();
}

const ROLE_LABELS: Record<AdminRole, string> = {
  FOUNDER: 'Founder',
  HOD: 'Head of Department',
  SENIOR_MANAGER: 'Senior Manager',
  MANAGER: 'Manager',
  EXECUTIVE: 'Executive',
  TRAINEE: 'Trainee',
};

export function formatRoleLabel(
  role: AdminRole | null | undefined,
  userType?: string | null,
): string {
  const resolved = role ?? normalizeRole(null, userType);
  return ROLE_LABELS[resolved] ?? 'Admin';
}
